/**
 * The custom line icon set (DESIGN.md §7): 24 × 24, 1.75 stroke, round caps and joins,
 * `currentColor`. Paths from design/reference/Foundations.dc.html.
 */
export const ICONS = {
  search: 'M11 4a7 7 0 1 0 0 14a7 7 0 0 0 0-14z M20 20l-4.2-4.2',
  plus: 'M12 5v14 M5 12h14',
  minus: 'M5 12h14',
  close: 'M6 6l12 12 M18 6L6 18',
  check: 'M5 12.5l4.5 4.5L19 7',
  'chevron-left': 'M15 5l-7 7 7 7',
  'chevron-right': 'M9 5l7 7-7 7',
  'chevron-down': 'M6 9l6 6 6-6',
  heart:
    'M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.1a4.3 4.3 0 0 1 7.5 2.7C19.5 15.4 12 20 12 20z',
  star: 'M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z',
  clock: 'M12 3.5a8.5 8.5 0 1 0 0 17a8.5 8.5 0 0 0 0-17z M12 7.5V12l3 2',
  users:
    'M9 11a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7z M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6 M16 4.5a3.5 3.5 0 0 1 0 6.5 M18 14.5c1.8.8 3 2.6 3 5.5',
  flame:
    'M12 21c-3.9 0-6.5-2.7-6.5-6.2 0-3.7 3-5.6 3.8-9.3 2 1.3 3.2 3.2 3.4 5.1 1-.7 1.6-1.8 1.8-3 1.7 1.7 4 4.2 4 7.2 0 3.5-2.6 6.2-6.5 6.2z',
  euro: 'M17.5 6.5a7 7 0 1 0 0 11 M4 10.5h9 M4 13.5h9',
  book: 'M4 5.5A1.5 1.5 0 0 1 5.5 4H11v16H5.5A1.5 1.5 0 0 1 4 18.5z M20 5.5A1.5 1.5 0 0 0 18.5 4H13v16h5.5a1.5 1.5 0 0 0 1.5-1.5z',
  calendar:
    'M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z M4 10h16 M8 3v4 M16 3v4',
  basket:
    'M3 9h18l-1.6 9.2a2 2 0 0 1-2 1.8H6.6a2 2 0 0 1-2-1.8z M8 9l3-5 M16 9l-3-5 M9 13v3 M15 13v3',
  sliders: 'M4 7h9 M17 7h3 M4 17h3 M11 17h9 M15 5v4 M9 15v4',
  timer: 'M12 21a8 8 0 1 0 0-16a8 8 0 0 0 0 16z M12 9v4l2.5 1.5 M9.5 2.5h5',
  play: 'M8 5.5v13l10-6.5z',
  pause: 'M8.5 5v14 M15.5 5v14',
  share:
    'M12 3v12 M7.5 7.5L12 3l4.5 4.5 M5 12v6.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V12',
  edit: 'M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16z M13.5 6.5l4 4',
  more: 'M5 11a1 1 0 1 0 0 2a1 1 0 0 0 0-2z M12 11a1 1 0 1 0 0 2a1 1 0 0 0 0-2z M19 11a1 1 0 1 0 0 2a1 1 0 0 0 0-2z',
  'cloud-off':
    'M3 3l18 18 M8.5 6.2A6 6 0 0 1 17.7 10H18a4 4 0 0 1 2.3 7.3 M16.5 19H7a5 5 0 0 1-2.7-9.2',
  sync: 'M20 12a8 8 0 0 1-14.3 4.9 M4 12a8 8 0 0 1 14.3-4.9 M18.5 3v4.5H14 M5.5 21v-4.5H10',
  link: 'M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1 M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1',
  clipboard:
    'M9 3.5h6v3H9z M9 5H6.5A1.5 1.5 0 0 0 5 6.5v13A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 17.5 5H15',
  image:
    'M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z M4 16l4.5-4.5 4 4 2.5-2.5L20 18 M15.5 8.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2z',
  text: 'M5 6h14 M5 10h14 M5 14h9 M5 18h6',
  video: 'M3.5 6.5h11v11h-11z M14.5 10.5l6-3.5v10l-6-3.5z',
  leaf: 'M5 19c0-8 5-13 14-14 0 9-5 14-13 14z M5 19l7-7',
  snowflake:
    'M12 3v18 M4.2 7.5l15.6 9 M4.2 16.5l15.6-9 M9.5 4.5L12 7l2.5-2.5 M9.5 19.5L12 17l2.5 2.5',
  box: 'M4 8l8-4 8 4v8l-8 4-8-4z M4 8l8 4 8-4 M12 12v8',
  sort: 'M7 4v16 M4 7l3-3 3 3 M17 20V4 M14 17l3 3 3-3',
  filter: 'M4 6h16 M7 12h10 M10 18h4',
  alert: 'M12 4l9 16H3z M12 10v4 M12 17h.01',
  info: 'M12 3.5a8.5 8.5 0 1 0 0 17a8.5 8.5 0 0 0 0-17z M12 11v5 M12 8h.01',
  key: 'M15 3.5a5.5 5.5 0 1 0 0 11a5.5 5.5 0 0 0 0-11z M11 13L3.5 20.5 M6.5 17.5l2.5 2.5 M16.5 8h.01',
  copy: 'M9 9h11v11H9z M5 15H4V4h11v1',
  bell: 'M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15z M10 20.5a2 2 0 0 0 4 0',
  sun: 'M12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8z M12 2.5v2 M12 19.5v2 M2.5 12h2 M19.5 12h2 M5.3 5.3l1.4 1.4 M17.3 17.3l1.4 1.4 M5.3 18.7l1.4-1.4 M17.3 6.7l1.4-1.4',
  trash: 'M4 7h16 M9 7V4.5h6V7 M6.5 7l1 13h9l1-13',
  globe:
    'M12 3.5a8.5 8.5 0 1 0 0 17a8.5 8.5 0 0 0 0-17z M3.5 12h17 M12 3.5c2.4 2.5 3.5 5.3 3.5 8.5s-1.1 6-3.5 8.5c-2.4-2.5-3.5-5.3-3.5-8.5s1.1-6 3.5-8.5z',
  user: 'M12 12a4 4 0 1 0 0-8a4 4 0 0 0 0 8z M4.5 20.5c.8-3.8 3.8-6 7.5-6s6.7 2.2 7.5 6',
  'arrow-right': 'M5 12h14 M13 6l6 6-6 6',
  external: 'M14 4h6v6 M20 4l-9 9 M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  grid: 'M4 4h7v7H4z M13 4h7v7h-7z M4 13h7v7H4z M13 13h7v7h-7z',
  list: 'M4 6h16 M4 12h16 M4 18h16',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z M12 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6z',
} as const;

export type IconName = keyof typeof ICONS;
export const ICON_NAMES = Object.keys(ICONS) as IconName[];
